import React from 'react';
import { FDBox, FDPaper } from '@facet-wealth/design';
import Proptypes from 'prop-types';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';


export const Disclosure = ({ value, disablePadding }) => {
  if (!value) {
    return null;
  }
  return (
    <FDBox padding={disablePadding ? 0 : 2}>
      <FDPaper color={'subtle'} appearance={'flat'} padding={disablePadding ? 0 : 2}>
        <Richtext
            // We have nothing better to use for the key than the array index
            // eslint-disable-next-line react/no-array-index-key
          size={'sm'}
          value={value}
          richtext
        />
      </FDPaper>
    </FDBox>
  );
};

Disclosure.defaultProps = {
  value: null,
};

Disclosure.propTypes = {
  value: Proptypes.string,
};
